import { StartOverInformationFragment } from '../dataProviders/__generated__/StartOver';

export function epochTime() {
  return Date.now() / 1000;
}

export function findCurrentProgram<T extends StartOverInformationFragment>(
  epgEntries?: (T | null)[] | null
): T | null {
  return (
    epgEntries?.find(e => e?.start && e.stop && e.start < epochTime() && e.stop > epochTime()) ??
    null
  );
}
